module.exports = __webpack_public_path__ + "img/box-2.407aabea.png";